import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgIf } from '@angular/common';
import { SoftwareService } from '../../../../core/services/software.service';

@Component({
  selector: 'app-software-version',
  standalone: true,
  imports: [NgIf],
  templateUrl: './version.component.html',
  styleUrl: './version.component.scss'
})
export class VersionComponent {
  private route = inject(ActivatedRoute);
  private ss = inject(SoftwareService);

  line = this.ss.getLine(this.route.snapshot.paramMap.get('line') as any);
  version = (this.route.snapshot.paramMap.get('version') || '').toUpperCase();
}
